import { atom } from 'recoil';

import { ClubsEntityNormalized } from '../types';

export const clubsLoadedState = atom({
  key: 'clubsLoadedState',
  default: { data: [] as ClubsEntityNormalized[], loaded: false, meta: {} as any },
});
